import { PageTitleNavs } from "@/common/components/page-title-navs";
import Scanner, { ScannedItem } from "@/common/components/scan";
import { DELIVERIES, RECALL_RESPONSE } from "@/common/constants";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";
import { useCallback, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { handleScannedItem, scanTableHeaders, scanTableKeys } from "../data";

const ScanWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .text-wrapper {
    padding: 2rem 2rem 1rem;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme.border.light};

    h2 {
      font-size: 1.5rem;
      font-weight: 600;
      color: ${({ theme }) => theme.text.primary};
      text-transform: capitalize;

      @media (max-width: ${({ theme }) => theme.screen.mobile}) {
        font-size: 1.1rem;
      }
    }
  }

  .containerWrapper {
    background-color: white;
    padding: 2rem 3rem;
    width: 100%;
    .top-wrapper {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .cta {
      margin-top: 1rem;
      display: flex;
      justify-content: center;
    }
  }
`;

function ScanToRecieve() {
  const makeRequest = useApiCallHandling();
  const navigate = useNavigate();
  const [loadingRecall, setLoadingRecall] = useState<boolean>(false);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const source = searchParams.get("from");
  const [serialKey, setSerailKey] = useState<string[]>([]);

  const handleScanSerial = (serial: string): Promise<ScannedItem[]> => {
    return new Promise((resolve) => {
      makeRequest(
        RECALL_RESPONSE + `/identify?serial_number=${serial}`,
        "GET",
        {},
        (data) => {
          resolve(handleScannedItem(data));
          setSerailKey((prev) => [...prev, serial]);
        },
        () => resolve([]),
        () => {},
      );
    });
  };

  const handleProceed = (items: ScannedItem[]) => {
    const payload = {
      serial_numbers: items.map((item) => item.unitSerial?.value),
      scanned_serials: serialKey,
    };
    setLoadingRecall(true);
    makeRequest(
      RECALL_RESPONSE + "/batch-recover",
      "POST",
      payload,
      () => navigate("/dashboard/recall"),
      console.log,
      () => setLoadingRecall(false),
    );
  };

  const handleConfirmDelivery = useCallback(() => {
    const payload = {
      scanned_serials: serialKey,
    };
    // console.log(payload); //==> test sake
    // return;
    setLoadingRecall(true);
    makeRequest(
      DELIVERIES + `/${id}/receive`,
      "PATCH",
      payload,
      () =>
        navigate(
          source === "recall" ? "/dashboard/recall" : "/dashboard/deliveries",
        ),
      console.log,
      () => setLoadingRecall(false),
    );
  }, [id, makeRequest]);

  const link =
    source === "recall" ? "/dashboard/recall" : "/dashboard/deliveries";

  return (
    <ScanWrapper>
      <PageTitleNavs
        title="Scan To Receive"
        backLink={link}
        bcrumbs={[
          {
            title: `${source === "recall" ? "Recall" : "Deliveries"}`,
            link: link,
          },
        ]}
      />
      <div className="text-wrapper">
        <h2>Scan To Receive</h2>
      </div>
      <div className="containerWrapper">
        <Scanner
          tableHeaders={scanTableHeaders}
          tableKeys={scanTableKeys}
          onScanSerial={handleScanSerial}
          onProceed={
            source === "recall" ? handleProceed : handleConfirmDelivery
          }
          loadingProceed={loadingRecall}
          proceedLabel="Proceed"
        />
      </div>
    </ScanWrapper>
  );
}

export default ScanToRecieve;
